import { LEVELS } from 'constants/index';

const { STEP_ONE, JUNIOR, PROFESSIONAL, SENIOR } = LEVELS;
const assignNumericValueValueToLevel = level => {
  /* eslint-disable indent */
  switch (level) {
    case STEP_ONE:
      return 4;
    case JUNIOR:
      return 3;
    case PROFESSIONAL:
      return 2;
    case SENIOR:
      return 1;
    default:
      return null;
  }
};
export default assignNumericValueValueToLevel;
